import React from "react";
import { get } from "lodash";

import { buildAssignOptions, folderFromMenuKey } from "../../utils/referralFolders";

const getDisplayName = (name) => {
  const reg = /_[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
  return name.replace(reg, "").replace("Refferal", "Referral");
};

// The assign control is a native select pinned to its placeholder, so it reads as a bare
// "…" at rest and hands the chosen folder straight to onChange. A native list is never
// clipped by the scrolling row list and needs no popup, portal or animation library.
const AssignControl = ({ referral, specialityNames, isAssigning, onAssignReferral }) => (
  <select
    className="referral-row-assign"
    value=""
    disabled={isAssigning}
    aria-label={`Assign ${getDisplayName(referral.fileName)} to a speciality`}
    onChange={(event) => onAssignReferral(referral, folderFromMenuKey(event.target.value))}
  >
    <option value="" disabled hidden>
      …
    </option>
    {buildAssignOptions(specialityNames, get(referral, "specialityName", "")).map(({ value, label, disabled }) => (
      <option key={value} value={value} disabled={disabled}>
        {label}
      </option>
    ))}
  </select>
);

const ReferralList = ({
  referrals,
  activeReferral,
  onSelectReferral,
  specialityNames,
  assigningReferralId,
  onAssignReferral,
}) => {
  return (
    <div
      style={{ overflowY: "scroll", overflowX: "hidden", height: "calc(100vh - 330px)" }}
      className="panel is-link is-radiusless is-shadowless"
    >
      {referrals.map((referral) => {
        const status = get(referral, "status", "");
        const isLoading = status === "PENDING";
        const isFailed = status === "FAILED";
        const isCompleted = status === "COMPLETED";

        return (
          <div
            className={`panel-block referral-row is-flex is-align-items-center ${
              activeReferral?.id === referral.id ? "has-background-light" : ""
            }`}
            style={{
              borderRadius: "8px",
              margin: "8px",
            }}
            key={`${referral.id}`}
          >
            <a
              href="/"
              className="referral-row-link"
              onClick={(event) => {
                event.preventDefault();
                onSelectReferral(referral);
              }}
            >
              <span className="panel-icon" key={get(referral, "status", "")}>
                <i
                  className={`fas ${
                    isLoading
                      ? "fa-spinner"
                      : isFailed
                      ? "fa-exclamation-circle has-text-danger"
                      : isCompleted
                      ? "fa-check-circle has-text-success"
                      : "fa-info-circle"
                  }`}
                  aria-hidden="true"
                />
              </span>
              <div className="is-flex is-flex-direction-column">
                <p
                  className={`is-size-7 has-text-weight-semibold m-0 ${
                    activeReferral?.id === referral.id ? "has-text-link " : ""
                  } ${isLoading ? "has-text-warning" : ""} ${isFailed ? "has-text-danger" : ""} ${
                    isCompleted ? "has-text-success" : ""
                  }`}
                >
                  {getDisplayName(referral.fileName)}
                </p>
                {isFailed && <p className="is-size-7 has-text-grey m-0">Processing error</p>}
                {isCompleted && <p className="is-size-7 has-text-grey m-0">Ready for review</p>}
                {get(referral, "specialityName", "") && (
                  <p className="is-size-7 has-text-grey m-0">{get(referral, "specialityName")}</p>
                )}
              </div>
            </a>
            <AssignControl
              referral={referral}
              specialityNames={specialityNames}
              isAssigning={assigningReferralId === referral.id}
              onAssignReferral={onAssignReferral}
            />
          </div>
        );
      })}
    </div>
  );
};

export default ReferralList;
